export default [
  {
    displayText: "Plaster her face.",
    textOptions: [
      (p, c) =>
        `${p.name} groans as ${p.pn.her} balls churn with nut batter, grabbing ${c.name} by the hair ${p.pn.she} presses ${p.pn.her} cock against her face.

      “My heavy balls need cover your pretty little face.”
      
      Releasing, ${p.pn.she} lets the tide of warm spunk burst over the girl, spraying thick ropes onto her eyes, her ${c.hairColor} hair and lips. With a few more rough pumps every last drop of fresh warm cum is now plastered over her face, ${c.name} can barely open her eyes from the thick coating, making her look like a glazed donut.
      
      ${p.name} wipes ${p.pn.her} cock clean with ${c.name}’s hair.`,
    ],
  },
  {
    displayText: "Cum down her throat.",
    textOptions: [
      (p, c) =>
        `${p.name} roughly grabs ${c.name} by the hair and pulls her face to ${p.pn.her} cock.

        “Hope your hungry, because its feeding time!”
        
        ${p.name} then quickly plunges ${p.pn.her} cock into her mouth, and pulling on the back of her head, pushes ${p.pn.her} cock way down the back of her throat. Groaning loadly ${p.pn.she} lets ${p.pn.her} cock release its bulging load. ${c.name} pulls back fruitlessly as a wave of thick, warm cum is pumped down her throat, ${p.name} holds tight as ${p.pn.she} lets every last drop of hot, fresh ball gravy pours into the restriced girl.
        
        “Fuuuck, oh your gonna be a good girl and swallow it all.”
        
        ${p.pn.Cshe} lets the last few drips spray into her, slowly pulling ${p.pn.her} cock free as the the last of ${p.pn.her} semen drips into Kim’s stomach.`,
      (p, c) => `
      ${p.name} groaned as ${p.pn.she} felt ${p.pn.her} balls ready to burst.
      
      Roughly ${p.pn.she} grabbed ${c.name} by the hair and pluged  ${p.pn.her} pulsing cock deep into the girls throat.
      
      ${p.pn.Cher} balls immediatly began firing a huge stream of hot cream down her throat. Ignoring the inexperienced female's gagging and clear disgust, ${p.name} kept up a thick flow of cum till her little mouth was overflowing.
      
      ${p.pn.Cshe} relished in the sight of a resigned ${c.name} futilely attempting to hold in the huge syrupy delivery. Slowly ${p.pn.she} freed ${p.pn.her} slathered, messy cock form the abused girl’s mouth, sliding the creamy coating off with ${p.pn.her} hand and depositing the remain onto ${c.name}’s weeping face.
      ${p.name} groaned, ‘Damn sexy, my cock loved your face, look how shiny it is, but still it isn’t nearly clean enough, now hurry up and devour my milky gift, there’s still some left to clean up! But leave your face, a good cum-slut always has a face-mask of tears and cum.’
      
      ${c.name} sniffled as she continued to drain the cauldron of cum that filled her mouth almost to the brim, her head tilted back. ${c.name}'s mouth gurgled as she fought to keep the overpowering musky taste down, it was the biggest load by far she faced, fow now.
      
      Finally she finished, breathing in a few strained breaths, before ${p.name} gave her a deep kiss, "amazing, your gonna be a star one day, most girls can’t handle one of my big loads.", ${c.name} nodded sobbing a little and wiping away tears to leave a dark mascara stain. ${p.name} coughed, and presented ${c.name} her shiny cum slathered cock, a fat vein of cum ran from her glans to all down her shaft, submissively the girl sucked up the remaining rope, and took a moment to try and regain her composure.`,
    ],
  },
  {
    displayText: "Cover her tits.",
    textOptions: [
      (
        p,
        c
      ) => `${p.name} moaned loader as ${p.pn.she} reached ${p.pn.her} peak, rubbing herself vigorously between ${c.name}’s alluring breasts. With a load animal grunt, ${p.pn.she} exploded, ${p.name}’s pumping member blew thick, gloopy strands over her bust, eliciting a load ‘eek’, more followed straight after. Thick creamy ropes came one after another, plastering her tits with a sticky white coating. A few more pumps, extracting every last drop from ${p.pn.her} sore nuts, and ${c.name}’s tits where a sloppy cum glazed mess. 

${p.name} took a deep breath.

${p.name} smiled, and pulled out ${p.pn.her} camera, ignoring ${c.name}’s pissed expression and tears. ${p.pn.Cshe} took a selfie of her, with ${p.pn.her} cum slathered cock rested on her head, making her look like a taken prize. Then ${p.pn.she} took a few close-ups of the sloppy mess that was ${c.name}'s chest.`,
    ],
  },
  {
    displayText: "Spunk on her back.",
    textOptions: [
      (
        p,
        c
      ) => `${p.name}, pumps ${p.pn.her} hard cock, driving ${p.pn.her}self over the line, pulling ${c.name} to the floor, on her front, ${p.pn.she} admires the soft curves of her back.

      “What lovely skin, all it needs is a nice layer of white streaks.”
      
       ${p.pn.Cher} cock shivers as a rain of fresh, white cum is sprayed over ${c.name}’s back, ${p.pn.she} gently massages ${p.pn.her} squirting penis, firing of a few more thick ropes over the girls back, covering it in long streaks of milky white cum.
      
      “perfect” ${p.pn.she} smiles, admiring ${p.pn.her} work..`,
    ],
  },
  {
    displayText: "Creampie deep in her arse.",
    textOptions: [
      (p, c) =>
        `${p.name} pulls ${c.name} in close and slowly pushes ${p.pn.her} cock into her back passage, groaning as ${p.pn.she} presses the girl into ${p.pn.self}self.

      “Fuck your arse is a delight, I’m gonna have to fill it with my fresh warm spunk!”
      
       ${p.pn.Cshe} lets loose, and ${p.pn.her} balls release their heavy load, huge spurts of thick, creamy semen are squirted into ${c.name}’s arse, she whimpers as the giant load load warms her inside and her prostate is tickled by ${p.pn.her} cock. ${p.name} expels the last of ${p.pn.her} milky load deep into her arse, and slowly pulls free, taking a moment to admire the thin streak of cum leaking from her hole.`,
    ],
  },
  {
    displayText: "Blow the load in her pussy.",
    textOptions: [
      (
        p,
        c
      ) => `${p.name} pulls ${c.name} in close and slowly pushes ${p.pn.her} cock into her wet pussy, groaning as ${p.pn.she} presses the girl into ${p.pn.self}self.

    “Fuck! your cunt is amazing, I’m gonna have to drown it with a big creamy load”
    
    ${p.pn.Cshe} lets loose, and ${p.pn.her} balls release their heavy load, huge spurts of thick, creamy semen are squirted into ${c.name}’s pussy, she whimpers as the giant load load warms her inside and drenches her baby maker. ${p.name} expels the last of ${p.pn.her} milky load deep into her, and slowly pulling free, taking a moment to admire the thin streak of cum leaking from her pussy lips.`,
    ],
  },
];
